<div class="card-header mb-3">
  <div class="title-section">
    <h2 class="header-title">Reporte {{ reportName }}</h2>
  </div>
  <div class="button-section">
    <button mat-flat-button class="btn-back" (click)="goBack()">
      <mat-icon>arrow_back</mat-icon>
      Volver
    </button>
  </div>
</div>
<div class="documentator-cont">
  <iframe [src]="safeUrl" width="100%" height="100%" style="border: none; min-height: 500px"></iframe>
</div>
